import { useEffect, useState } from "react";
import { consumePatientLink } from "../lib/patientLinks";
import MedicalCalculators from "./MedicalCalculators";

interface Props {
  token: string;
}

type Status = "loading" | "valid" | "invalid";

export default function PatientLinkGate({ token }: Props) {
  const [status, setStatus] = useState<Status>("loading");
  const [calcId, setCalcId] = useState<string>("");

  useEffect(() => {
    if (!token) { setStatus("invalid"); return; }
    consumePatientLink(token).then((result) => {
      if (result) {
        setCalcId(result.calcId);
        setStatus("valid");
      } else {
        setStatus("invalid");
      }
    });
  }, [token]);

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-600 font-medium">جاري التحقق من الرابط...</p>
        </div>
      </div>
    );
  }

  if (status === "invalid") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
        <div className="bg-white rounded-2xl shadow-lg border border-red-100 p-8 max-w-md w-full text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h1 className="text-xl font-black text-slate-800 mb-2">انتهت صلاحية هذا الرابط</h1>
          <p className="text-slate-500 text-sm leading-relaxed">
            هذا الرابط صالح للاستخدام مرة واحدة فقط أو انتهت صلاحيته.
            <br />يرجى التواصل مع طبيبك للحصول على رابط جديد.
          </p>
          <p className="text-xs text-slate-400 mt-4 font-mono" dir="ltr">
            This link has already been used or has expired.
          </p>
        </div>
      </div>
    );
  }

  return <MedicalCalculators defaultCalculator={calcId} isPatientMode={true} />;
}
